export const LOGIN_EVENT = "need-login";

export const LOGIN_SUCCESS = "login-success";

export const CASH_BACK = 10;

export const HIDE_ASSISTANT_EVENT = "hide-assistant";
